/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { reducer as reduxFormReducer } from 'redux-form';
import { COMPONENT_FORM } from '@hbrisk/sp3-risk-model-support/components/form/name.js';
import componentFields from '@hbrisk/sp3-risk-model-support/components/form/fields/index.js';
import { modelTypes } from '#src/js/constants/models/modelTypes/index.js';
import makeFormReducerPlugin from '#reducers/ui/form/support/makeFormReducerPlugin/index.js';

const modelFormPlugins = modelTypes.reduce((acc, modelType) => {
  const { modelFormName, fields } = modelType;
  return modelFormName
    ? {
        ...acc,
        [modelFormName]: makeFormReducerPlugin({ name: modelFormName, fields }),
      }
    : acc;
}, {});

const formReducer = reduxFormReducer.plugin({
  ...modelFormPlugins,
  [COMPONENT_FORM]: makeFormReducerPlugin({ name: COMPONENT_FORM, fields: componentFields }),
});

export default formReducer;
